import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { OrderAction } from 'src/actions/order.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    Select,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
    Table, 
    TableHead, 
    TableRow, 
    TableBody
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

const ErrorDialog = (props) => {
    const dispatch = useDispatch()
    const { errorRows } = useSelector(state => state.newdanhmuckhohang)

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>
                {`Lỗi import gần nhất${
                    Object.values(errorRows || {})[0]?.error_file
                    ? ` (${Object.values(errorRows)[0].error_file})`
                    : ""
                }:`}
            </DialogTitle>
            <DialogContent style={{ width: 600, paddingTop: 20 }}>
                <table width="100%">
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>Dòng</strong></TableCell>
                            <TableCell><strong>Mã lỗi</strong></TableCell>
                            <TableCell><strong>Dữ liệu lỗi</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {errorRows && Object.entries(errorRows).length && Object.entries(errorRows).map(([line, value]) => (
                        <TableRow key="{line}">
                            <TableCell>{Number(line) + 2}</TableCell>
                            <TableCell>{value.error_type}</TableCell>
                            <TableCell>{value.error_data}</TableCell>
                        </TableRow>
                        ))}
                    </TableBody>
                </table>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>OK</Button>
            </DialogActions>
        </Dialog >
    );
}

export default ErrorDialog;